import React, { useState, useCallback } from 'react'
import ReactResponsiveModal from 'react-responsive-modal'
import { useDispatch } from 'react-redux'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { Input } from '../../components/ModalInputs'
import ModalFooter from '../../components/ModalFooter/ModalFooter'
import { createEquipmentGroup, updateEquipmentGroup } from '../../actions/equipmentGroups'
import styles from './styles.module.css'
import Confirmation from '../../components/Confirmation/Confirmation'

const validationSchema = Yup.object({
  groupnum: Yup.string().required('Поле «Номер» обязательно для заполнения.'),
  groupname: Yup.string().trim().required('Поле «Название» обязательно для заполнения.').max(100, 'Должно быть не более 100 символов'),
})

export default function EquipmentGroupsModal({ data, closeModal }) {
  const dispatch = useDispatch()

  const [confirmClose, setConfirmClose] = useState(false)
  const acceptConfirmation = useCallback(() => { closeModal(); setConfirmClose(false) }, [closeModal])
  const rejectConfirmation = useCallback(() => setConfirmClose(false), [])

  const addMode = !data?.id

  const toPayload = (values) => ({
    groupnum: Number(values.groupnum),
    groupname: values.groupname.trim(),
  })

  const handleCreate = (values) => {
    dispatch(createEquipmentGroup(toPayload(values), closeModal))
  }

  const handleUpdate = (values) => {
    dispatch(updateEquipmentGroup(data.id, toPayload(values), closeModal))
  }

  const {
    values,
    errors,
    dirty,
    submitCount,
    setFieldValue,
    handleChange,
    handleSubmit
  } = useFormik({
    initialValues: {
      groupnum: data?.groupnum ?? '',
      groupname: data?.groupname ?? '',
    },
    validationSchema,
    onSubmit: addMode ? handleCreate : handleUpdate
  })

  const handleClose = useCallback(() => {
    if (dirty) setConfirmClose(true)
    else closeModal()
  }, [dirty, closeModal])

  // ошибки показываем только после «Сохранить», при вводе значения — скрываются
  const error = (fieldName) => submitCount > 0 && errors[fieldName]

  // «Номер» принимает только цифры (как в десктопе)
  const handleNumChange = (e) => setFieldValue('groupnum', e.target.value.replace(/\D/g, ''))

  return (
    <ReactResponsiveModal
      open={!!data}
      onClose={handleClose}
      showCloseIcon={false}
      closeOnOverlayClick={true}
      closeOnEsc={true}
      center
      classNames={{
        modal: styles.modal,
        modalContainer: styles.modalContainer
      }}
    >
      <>
        <div className={styles.modalMain}>
          <h2>{addMode ? 'Добавление группы оборудования' : 'Редактирование группы оборудования'}</h2>

          <div className={styles.inputsColumn}>
            <Input
              label='Номер'
              name='groupnum'
              value={values.groupnum}
              error={error('groupnum')}
              onChange={handleNumChange}
              inputMode='numeric'
              maxLength='9'
              required
              autoFocus
              labelStyle={{ width: '100%', maxWidth: '100%' }}
            />
            <Input
              label='Название'
              placeholder='до 100 символов'
              name='groupname'
              value={values.groupname}
              error={error('groupname')}
              onChange={handleChange}
              maxLength='100'
              required
              labelStyle={{ width: '100%', maxWidth: '100%' }}
            />
          </div>
        </div>

        <ModalFooter handleSubmit={handleSubmit} closeModal={closeModal} />
        {confirmClose && (
          <Confirmation
            title="Закрыть без сохранения изменений?"
            acceptConfirmation={acceptConfirmation}
            rejectConfirmation={rejectConfirmation}
          />
        )}
      </>
    </ReactResponsiveModal>
  )
}
